import { useEffect, useState } from "react";
import { getBalanceRequests } from "../../services/vehicleService";
import { Card, Container, Number, Title } from "./BalanceRequestsStyles";

export default function BalanceRequests() {
  const [balance, setBalance] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchBalance() {
      try {
        const result = await getBalanceRequests();
        setBalance(result.data ?? null);
      } catch (err) {
        console.error("Erro ao buscar saldo:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchBalance();
  }, []);

  return (
    <Container>
      <Card>
        <Title>Consultas restantes</Title>
        {loading ? <p>Carregando...</p> : <Number>{balance}</Number>}
      </Card>
    </Container>
  );
}
